'use strict';

var angularModule = angular.module('t2g.common.directives.priceInputDirective', []);

module.exports = angularModule;

angularModule.directive('priceInput', function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function($scope, $element, $attributes, ngModelController) {
      ngModelController.$parsers.push(function(data) {
        var floatyValue = data
          .toString()
          .trim()
          .replace(',', '.')
          .replace(/[^\d.,]/g, '');
        var floatValue = parseFloat(floatyValue);
        var stringValue = !isNaN(floatValue) ? floatyValue : '';
        var modelValue = !isNaN(floatValue) ? floatValue : undefined;

        ngModelController.$setViewValue(stringValue);
        ngModelController.$commitViewValue();
        ngModelController.$render();

        return modelValue;
      });
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/directives/priceInputDirective.js